export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9503.d688b55a.jpg";